import styled from 'styled-components'
import { breakpoints, pxToRems } from '@awaze/design-system.utils.react'
import { IconButton } from '@awaze/design-system.components.button'
import { HTMLAttributes } from 'react'

export const HeroContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;

  @media screen and (min-width: ${breakpoints[0]}px) {
    display: flex;
  }

  > button {
    display: none;
    opacity: 0;
    transition: opacity 0.1s ease-in-out;

    @media screen and (min-width: ${breakpoints[0]}px) {
      display: flex;
    }
  }

  &:hover > button {
    opacity: 1;
  }
`

export const StyledImageWrapper = styled.div`
  height: 100%;
  width: 100%;

  & + div {
    display: none;
  }

  @media screen and (min-width: ${breakpoints[0]}px) {
    & + div {
      display: block;
    }
  }
`

export const AspectRatio = styled.div`
  height: 100%;
  width: 100%;
  aspect-ratio: 375 / 288;

  position: relative;

  @media screen and (min-width: ${breakpoints[0]}px) {
    aspect-ratio: 768 / 440;
  }

  @media screen and (min-width: ${breakpoints[1]}px) {
    aspect-ratio: 692 / 384;
  }
`

interface StyledImageProps {
  comingSoon: boolean
  isFloorplan: boolean
}

export const StyledImage = styled.img<StyledImageProps>`
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 100%;
  height: 100%;
  object-fit: ${({ isFloorplan }) => (isFloorplan ? 'contain' : 'cover')};
  cursor: pointer;
`

interface StyledStaticGridHeroItemProps extends HTMLAttributes<HTMLDivElement> {
  index: number
}

export const StyledIconButton = styled(IconButton)`
  position: absolute;
  z-index: 1;
  display: none;

  @media screen and (min-width: ${breakpoints[1]}px) {
    top: ${pxToRems(24)};
    right: ${pxToRems(24)};
    display: block;
  }
`

export const StyledComingSoonPlaceholder = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.ColorGrey100};
`

export const DescriptivePaginationCountContainer = styled.section<{
  shouldDiplayPaginationText?: boolean
}>`
  z-index: 2;
  display: flex;
  align-items: center;
  position: absolute;
  bottom: 12px;
  left: 12px;
  padding: 6px 8px;
  background-color: ${({ theme }) => theme.ColorWhiteOpacity100};
  & > button {
    display: flex;
    align-items: center;
    font-size: 12px;
    @media (min-width: ${breakpoints[0]}px) {
      font-size: 14px;
    }
    & > span {
      display: flex;
    }
    & > svg {
      fill: ${({ theme }) => theme.ColorThemeLink} !important;
    }
  }
`

export const StyledNavigationPreviousButton = styled.button`
  position: absolute;
  top: 50%;
  width: auto;
  display: flex;
  justify-content: space-between;
  transform: translateY(-50%);
  z-index: 11;
  left: 3%;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  aspect-ratio: 1 / 1;
  padding: 0.25rem;
  border: none;
  cursor: pointer;

  &:hover {
    background-color: rgba(0, 0, 0, 0.7);
  }
`

export const StyledNavigationNextButton = styled.button`
  position: absolute;
  top: 50%;
  width: auto;
  display: flex;
  justify-content: space-between;
  transform: translateY(-50%);
  z-index: 11;
  right: 3%;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  aspect-ratio: 1 / 1;
  padding: 0.25rem;
  border: none;
  cursor: pointer;

  &:hover {
    background-color: rgba(0, 0, 0, 0.7);
  }
`
